import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import omit from 'lodash/omit';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import HR from '@zg-rentals/multibrand-ui/lib/HR';
import Switch from '@zg-rentals/multibrand-ui/lib/Switch';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';
import UserManagementActions from 'app/shared/actions/UserManagementActions';

import { UserManagementSelectors } from 'app/shared/selectors';

import './style.scss';

const propTypes = {
    currentUser: PropTypes.object.isRequired,
};

const PermissionSwitch = ({
    permission,
    description,
    active,
    onPermissionChange,
}) => (
    <div className="AddUserPage-list-box-item flex">
        <div className="AddUserPage-list-header">
            <Text type="h5">{description}</Text>
        </div>
        <div>
            <Switch
                on={active}
                onClick={() => onPermissionChange(permission, !active)}
            />
        </div>
    </div>
);

const Permissions = ({
    onCancel,
    onBack,
    onNextStep,
    dispatch,
    handleSaveComplete,
    currentUser,
}) => {
    const { isInvitation } = currentUser;

    const otherPermissions = omit(UserPermissionsConstants.PERMISSIONS, [
        UserPermissionsConstants.PERMISSIONS.COMPANY_ADMIN,
        UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES,
        UserPermissionsConstants.PERMISSIONS.COMPANY_USER,
    ]);

    const handleUpdatePermission = (permission) => {
        const newPermissions = {
            ...currentUser.permissions,
            [permission]: !currentUser.permissions[permission],
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    return (
        <div>
            <Row>
                <Col>
                    <Text type="h3">{`Set ${currentUser.userName}'s permissions`}</Text>
                </Col>
            </Row>
            <div className="AddUserPage-list-box">
                <div className="AddUserPage-list-box-body">
                    {Object.keys(otherPermissions).map(permission => (
                        <PermissionSwitch
                            key={permission}
                            permission={permission}
                            onPermissionChange={() => handleUpdatePermission(permission)}
                            title={UserPermissionsConstants.DESCRIPTION[permission].TITLE}
                            description={UserPermissionsConstants.DESCRIPTION[permission].DESCRIPTION}
                            active={currentUser.permissions[permission]}
                        />
                    ))}
                </div>
            </div>
            <HR />
            <div className="Questions-footer">
                <Link className="Questions-button" onClick={onCancel}>
                    Cancel
                </Link>
                <div>
                    <Link className="Questions-button" onClick={onBack}>
                        Back
                    </Link>
                    {isInvitation
                        ? (
                            <Button type="primary" onClick={onNextStep}>
                                Continue
                            </Button>
                        )
                        : (
                            <Button
                                type="primary"
                                onClick={() => dispatch(UserManagementActions.editableUserSave())
                                    .then(handleSaveComplete)}
                            >
                                Save
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
};

Permissions.propTypes = propTypes;

const mapStateToProps = state => ({
    currentUser: UserManagementSelectors.makeCurrentUser(state),
});

export default connect(mapStateToProps)(Permissions);
